import React, { Children, isValidElement, cloneElement } from 'react';
import classNames from 'classnames';
import { isAction, isItems, isTabbedView, isEmpty } from './roles';
import { invalidChildWarning } from './invalidChildWarning';

/*::
type Props = {
  title?: string,
  displayCount?: boolean,
  description?: string,
  className?: string,
  customCount?: number,
  items?: Array<ContentGroup.Action|ContentGroup.Items>,
  children?: Array<React.ReactChild>,
}
*/

const ContentGroup = (
  {
    title,
    displayCount,
    description,
    className,
    customCount,
    items,
    children,
  } /*: Props */,
) => {
  let contentGroupAction;
  let contentGroupTabbedView;
  let contentGroupItems;
  let contentGroupEmptyScreen;

  Children.forEach(children, child => {
    if (!isValidElement(child)) return;

    if (isAction(child)) {
      contentGroupAction = child;
    } else if (isItems(child)) {
      contentGroupItems = cloneElement(child, { items });
    } else if (isTabbedView(child)) {
      contentGroupTabbedView = child;
    } else if (isEmpty(child)) {
      contentGroupEmptyScreen = child;
    } else {
      invalidChildWarning(child);
    }
  });

  const showCount = customCount || displayCount;

  const containerClassName = classNames('ContentGroup', className);
  const contentGroupHeaderClassName = classNames('ContentGroup-header', {
    'ContentGroup-header--withTabbedView': contentGroupTabbedView,
  });

  return (
    <div className={containerClassName}>
      <div className={contentGroupHeaderClassName}>
        <div className="ContentGroup-title">
          {title && <span>{title}</span>}
          {showCount && (
            <span className="ContentGroup-count">
              {customCount || items.length}
            </span>
          )}
        </div>
        {contentGroupTabbedView ? (
          <div className="ContentGroup-tabbedView">
            {contentGroupTabbedView}
            {contentGroupAction && contentGroupAction}
          </div>
        ) : (
          <>{contentGroupAction && contentGroupAction}</>
        )}
        {description && (
          <div className="ContentGroup-description">{description}</div>
        )}
      </div>
      {contentGroupEmptyScreen && contentGroupEmptyScreen}
      <div className="ContentGroup-contents">{contentGroupItems}</div>
    </div>
  );
};

export default ContentGroup;
